
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { LayoutComponent } from './pages/layout-page/layout.component';
import { PraxisComponent } from './praxis.component';
import { ContratarComponent } from './pages/contratar-page/contratar.component';
import { SolicitarPageComponent } from './pages/solicitar-page/solicitar-page/solicitar-page.component';
import { CotizacionComponent } from './pages/cotizacion-page/cotizacion.component';




const routes: Routes = [
  {
    path: '',
    component: PraxisComponent,
  },
  {
    path: 'contratar',
    component: ContratarComponent,
  },
  {
    path: 'solicitar',
    component: SolicitarPageComponent
  },

  {
    path: 'cotizacion',
    component: CotizacionComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PraxisRoutingModule {

}
